import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { InputClearBtnModule } from '../input-clear-btn/input-clear-btn.module';
import { InputErrorModule } from '../input-error/input-error.module';
import { CurrencyComponent } from './currency.component';

@NgModule({
  declarations: [CurrencyComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    InputClearBtnModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    InputErrorModule,
  ],
  exports: [CurrencyComponent],
})
export class CurrencyModule {}
